import { DOCUMENT } from '@angular/common';
import { AfterViewChecked, Component, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterState } from '@angular/router';
import { page_title } from './page.title';
declare let $: any;
declare var gtag: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent implements AfterViewChecked {
  isparam: boolean = true;
  pagepath: any;
  pagetitle: any;
  username: any;
  pageLoadTime: any;
  navigationStartTime: number;
  navigationEndTime: number;
  constructor(
    private router: Router,
    private titleService: Title,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.handleRouteEvents();
  }

  handleRouteEvents() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.navigationStartTime = performance.now();
      }
      if (event instanceof NavigationEnd) {
        let userDetails = JSON.parse(sessionStorage.getItem('user'));
        let region = JSON.parse(sessionStorage.getItem('region'));
        let role_name = userDetails?.userroles[0]?.name
        let user_id = userDetails?.id
        let user = sessionStorage.getItem('email');
        if (user !== undefined && user !== null) {
          this.username = user.split('@')[0];
        }
        const title = this.getTitle(this.router.routerState, this.router.routerState.root).join('-');
        this.navigationEndTime = performance.now();
        this.pageLoadTime = (this.navigationEndTime - this.navigationStartTime) / 1000;
        this.titleService.setTitle(title);
        const analyticsTitle = title.split('|')[0]?.trim() || title;
        gtag('event', 'page_view', {
          page_title: analyticsTitle,
          page_path: event.urlAfterRedirects,
          page_location: this.document.location.href,
          unique_id: this.username ? this.username : null,
          user__id: user_id,
          in_time: new Date(),
          role_name: role_name,
          region: region
        });

      }
    });
  }


  title = 'or-jjis';

  getTitle(state: RouterState, parent: ActivatedRoute): string[] {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data['title']) {
      data.push(parent.snapshot.data['title']);
    }
    else if (state && parent && parent.firstChild) {
      data.push(...this.getTitle(state, parent.firstChild));
    }
    else if (state && state?.snapshot?.url) {
      this.isparam = true;
      let urlLength = state.snapshot.url.split('/').length;
      for (let i = 1; this.isparam && urlLength - i >= 0; i++) {
        this.pagepath = state.snapshot.url.split('/')[state.snapshot.url.split('/').length - i];
        this.pagetitle = this.findPageTitle();
      }
      data.push(this.pagetitle);
    }
    return data;
  }
  private findPageTitle() {
    let title;
    page_title.forEach((element: any) => {
      if (this.pagepath == element.page) {
        this.isparam = false;
        title = element.title;
      } else if (this.pagepath.includes('?')) {
        if (this.pagepath.split('?')[0] == element.page) {
          this.isparam = false;
          title = element.title;
        }
      }
    });
    return title;
  }
  removeAttribute(comp: any, attr) {
    if (comp && comp.length > 0) {
      Object.values(comp).forEach((element: any) => {
        element.removeAttribute(attr);
      });
    }
  }
  setAttribute(comp: any, attr, val) {
    if (comp && comp.length > 0) {
      Object.values(comp).forEach((element: any) => {
        element.setAttribute(attr, val);
      });
    }
  }
  ngAfterViewChecked() {
    $('[data-toggle="tooltip"]').tooltip({
      trigger: 'hover'
    });
    $('[data-toggle="tooltip"]').on('mouseleave', function () {
      $(this).tooltip('dispose');
    });
    $('[data-toggle="tooltip"]').on('click', function () {
      $(this).tooltip('dispose');
    });
    this.setAttribute(document.getElementsByClassName('p-dialog-header-close'), 'aria-label', 'Close');
    this.setAttribute(document.getElementsByClassName('p-dialog-close-button'), 'aria-label', 'Close');
    const dialogs = document.getElementsByClassName('p-dialog p-component');
    if (dialogs && dialogs.length > 0) {
      Object.values(dialogs).forEach((element: any) => {
        const parentDialog = element.closest('p-dialog');
        if (parentDialog) {
          const labelledBy = parentDialog.getAttribute('aria-labelledby');
          if (labelledBy) {
            element.setAttribute('aria-labelledby', labelledBy);
          } else {
            const label = parentDialog.getAttribute('aria-label');
            if (label) {
              element.setAttribute('aria-label', label);
            } else {
              const currentLabelledBy = element.getAttribute('aria-labelledby');
              if (currentLabelledBy && !document.getElementById(currentLabelledBy)) {
                element.removeAttribute('aria-labelledby');
              }
            }
          }
          const role = parentDialog.getAttribute('role');
          if (role) {
            element.setAttribute('role', role);
          }
        } else {
          const currentLabelledBy = element.getAttribute('aria-labelledby');
          if (currentLabelledBy && !document.getElementById(currentLabelledBy)) {
            element.removeAttribute('aria-labelledby');
          }
        }
      });
    }

    let arr = [];
    arr.push(document.getElementById('goog-gt-votingInputSrcLang'));
    arr.push(document.getElementById('goog-gt-votingInputTrgLang'));
    arr.push(document.getElementById('goog-gt-votingInputSrcText'));
    arr.push(document.getElementById('goog-gt-votingInputTrgText'));
    arr.push(document.getElementById('goog-gt-votingInputVote'));
    arr.push(document.getElementById('g-recaptcha-response'));
    arr?.forEach(value => {
      value?.setAttribute('aria-label', 'translate');
    });
  }
}
